import { Row } from "@/common/custom-lists/ListView";
import {ClockIcon, PlayIcon, XCircleIcon, XMarkIcon} from "@heroicons/react/20/solid";
import { BuildingOffice2Icon } from "@/icons/solid";
import Tooltip from "@/tooltip";
import { format } from "date-fns";
import { connect } from "react-redux";
import { Actions as ADVISOR_ACTIONS } from "@/redux/actions/advisorActions";
import Spinner from "@/common/Spinner";
import * as PropTypes from "prop-types";


const reformatDate = (date) => {
	try {
		return format(new Date(date), "do MMM");
	} catch (e) {
		return "";
	}
};

const reformatTime = (date) => {
	try {
		return format(new Date(date), "HH:mm");
	} catch (e) {
		return "";
	}
};

const ScheduledTaskRow = ({
	task,
	deleteScheduledTask,
	runScheduledTask
}) => {
	const { id, companyName, entity, entityReference, action, date, status, year, startDate, endDate, processing } = task || {};

	return (
		<Row
			actionColumn={false}
			columns={[
				<div>
					<h5 style={{ paddingTop: "1rem" }}>
						<BuildingOffice2Icon
							style={{
								height: "1.725rem",
								marginRight: 5,
							}}
						/>
						{companyName}
					</h5>
				</div>,
				<div>
					{entity}: {entityReference}
					<div style={{ textWrap: "nowrap" }}>
						<div
							className="chip"
							style={{ background: "#ffdecd", color: "#ea611c", marginLeft: "0rem" }}
						>
							{reformatDate(startDate)}
							{startDate && endDate && " - "}
							{reformatDate(endDate)}
						</div>
						{year ? (
							<div
								className="chip"
								style={{
									background: "white",
									border: "1px solid #ea611c",
									color: "#ea611c",
									marginLeft: "0.5rem",
									marginRight: "0.5rem",
									display: "inline-block",
								}}
							>
								{year}
							</div>
						) : null}
					</div>
				</div>,
				<div style={{ paddingTop: "1rem" }}>{action}</div>,
				<div>
					{reformatTime(date)}
					<br />
					{reformatDate(date)}
					{year ? `, ${year}` : ""}
				</div>,
				<div style={{ paddingTop: "1rem" }}>{status}</div>,
				<div
					className="pull-left"
					style={{ paddingTop: "1rem" }}
				>

					{ processing || status === "Processing" ?
						<Spinner  style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                                        className="animate-spin -ml-1 mr-3 h-5 w-5 "
						 />
					: <>

						{["Failed", "Pending"].includes(status) ? (
							<button
								className="btn btn-success btn-xs mr-2"
								onClick={() => {runScheduledTask(id)}}
							>
								<Tooltip content="Run Now">
									<PlayIcon
										className="h-6 w-6"
										style={{ verticalAlign: "text-bottom" }}
									/>
								</Tooltip>
							</button>
						) : null}

						{["Pending"].includes(status) ? (
							<button
								className="btn btn-danger btn-xs"
								onClick={() => {deleteScheduledTask(id)}}
							>
								<Tooltip content="Cancel">
									<XMarkIcon
										className="h-6 w-6"
										style={{ verticalAlign: "text-bottom" }}
									/>
								</Tooltip>
							</button>
						) : null}
					</>}
				</div>,
			]}
		/>
	);
};

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({
	deleteScheduledTask: (id) => dispatch(ADVISOR_ACTIONS.deleteScheduledTask({id})),
	runScheduledTask: (id) => dispatch(ADVISOR_ACTIONS.runScheduledTask({id})),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledTaskRow);
